module.exports = __webpack_public_path__ + "static/img/summer_banner.b815e1e4.jpg";